import { PaletteColor, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { getRGBA } from 'utils/color'

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',

    '& h6': {
      margin: 0,
      padding: 0,
      font: 'Sora',
      fontSize: '1.25rem',
      lineHeigth: '2rem',
      fontWeight: '600',
    },
  },

  container: {
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    margin: '2.5rem 0',
  },

  title: {
    padding: 0,

    '& span': {
      fontFamily: 'Nunito !important',
      fontWeight: '400 !important',
      fontSize: '1rem !important',
      lineHeight: '1.5rem !important',
      color: '#0F0F1E !important',

      '& p': {
        padding: 0,
        margin: 0,
        textDecoration: 'underline',
        color: '#3300FF !important',
        cursor: 'pointer',
        transition: 'all 300ms ease-in-out',

        '&:hover': {
          color: `${getRGBA('#3300FF', 0.7)} !important`,
        },
      },
    },
  },

  item: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '0.015rem',

    '& p': {
      padding: 0,
      margin: 0,
      fontFamily: 'Nunito',
      fontWeight: '400',
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      color: '#0F0F1E',
    },

    '& span': {
      padding: 0,
      margin: 0,
      fontFamily: 'Nunito',
      fontWeight: '400',
      fontSize: '0.75rem',
      lineHeight: '1.25rem',
      color: getRGBA('#0F0F1E', 0.6),
    },
  },

  closeBtn: {
    cursor: 'pointer',
    transition: 'all 300ms ease-in-out',

    '&:hover': {
      color: (theme.palette.anger as PaletteColor).main,
    },
  },

  actions: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    gap: '0.5rem',
    paddingTop: '1.5rem',
  },

  submitButton: {
    height: '2.25rem !important',
    padding: '1rem !important',
    width: '5.3125rem !important',
    minWidth: '5.3125rem !important',
    maxWidth: '5.3125rem !important',
  },

  cancelButton: {
    height: '2.25rem !important',
    padding: '1rem !important',
    color: '#BA1A1A !important',
    border: `1px solid ${getRGBA('#BA1A1A', 0.5)} !important`,
  },
}))

export { useStyles }
